export default __webpack_public_path__ + "static/media/acaciawood.e91bb42f.PNG";